<template>
    <div>
        <UtilsContent @close-action="closeMusic">
            <template v-slot:header>
                <div class="d-flex flex-column justify-center align-start">
                    <div class="d-flex flex-row justify-start align-center mx-3 mb-4">
                        <img :src="musicImg" class="img-index mr-2" alt="" />
                        <span class="text-h5 ma-0 text--primary">
                            {{ $t('bookReading.music_2') }}
                        </span>
                    </div>
                    <div class="d-flex flex-row justify-start align-center mx-3 mb-4">
                        <span class="text-body-2 ma-0 text--primary text-left">
                            {{ $t('bookReading.music_msg_1') }}
                        </span>
                    </div>
                </div>
            </template>
            <template v-slot:content>
                <div class="d-flex flex-column mx-3">
                    <v-row justify="start" align="start">
                        <v-col cols="12" class="d-flex flex-column justify-start align-start">
                            <PreviusListenMusic
                                :isBookFunctionality="isBookFunctionality"
                                :isChallengeFunctionality="isChallengeFunctionality"
                            />
                        </v-col>
                        <v-col cols="12" class="d-flex flex-column justify-start align-start">
                            <VolumeSelector
                                :isBookFunctionality="isBookFunctionality"
                                :isChallengeFunctionality="isChallengeFunctionality"
                            />
                        </v-col>
                    </v-row>
                </div>
            </template>
            <template v-slot:actions>
                <v-row justify="center" align="center">
                    <v-btn
                        data-cy="music-activate-button"
                        color="secondary"
                        rounded
                        class="mt-4 mx-3 w-90 py-5 white--text"
                        @click="activateOrDesactivateBackgroundMusic"
                    >
                        {{
                            !isSound ? $t('bookReading.activate') : $t('bookReading.desactivate')
                        }}
                        {{ $t('bookReading.music_2') }}
                    </v-btn>
                </v-row>
            </template>
        </UtilsContent>
    </div>
</template>
<script>
/* eslint-disable global-require */
import { mapState } from 'vuex'

import UtilsContent from './UtilsContent.vue'
import PreviusListenMusic from './PreviusListenMusic.vue'
import VolumeSelector from './VolumeSelector.vue'

export default {
    props: {
        isBookFunctionality: { type: Boolean, default: false },
        isChallengeFunctionality: { type: Boolean, default: false }
    },
    components: {
        UtilsContent,
        PreviusListenMusic,
        VolumeSelector,
    },
    computed: {
        ...mapState({
            bookReadConf: (state) => state.bookReading.bookReadConf,
            challengeConf: (state) => state.challenge.config,
        }),
        isSound() {
            let result = this.bookReadConf && this.bookReadConf.soundActive
            if (this.isBookFunctionality) {
                return result
            }
            if (this.isChallengeFunctionality) {
                result = this.challengeConf && this.challengeConf.soundActive
            }
            return result
        },
    },
    data() {
        return {
            musicImg: require('@/assets/img/icons/reading/icon-music-2.svg'),
        }
    },
    methods: {
        closeMusic() {
            this.$emit('close-music')
        },
        activateOrDesactivateBackgroundMusic() {
            if (this.isBookFunctionality) {
                this.bookReadConf.soundActive = !this.bookReadConf.soundActive
            }
            if (this.isChallengeFunctionality) {
                this.challengeConf.soundActive = !this.challengeConf.soundActive
            }
        },
    },
}
</script>
<style>
.chapters-container {
    height: 35vh;
    max-height: 35vh;
    overflow: auto;
}
</style>
